<template>
  <div>
    <div class="c-popup__back-black" v-on:click="closePopup()"></div>
    <div class="c-popup__window">
      <div class="c-popup__close" v-on:click="closePopup()">
        <span></span>
        <span></span>
      </div>
      <div
        class="c-popup__inner"
        :class="
          'c-popup__box_txt-' + (confirmTxtColor ? confirmTxtColor : 'red')
        "
      >
        <div class="c-popup__box_txt01">確認</div>
        <div class="c-popup__box_txt03" v-html="confirmTxt"></div>
        <div class="c-popup_button_wrap">
          <div
            class="c-button c-button-black c-popup_button01"
            v-show="!cancelButtonNoneFlg"
            v-on:click="closePopup()"
          >
            {{ cancelButtonTxt ? cancelButtonTxt : "キャンセル" }}
          </div>
          <div
            v-show="clickButtonFlg"
            class="c-button c-popup_button01"
            :class="'c-button-' + (buttonColor ? buttonColor : 'blue')"
            v-on:click="execBtn()"
          >
            {{ buttonTxt }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PopupComponent",
  props: {
    confirmTxt: {
      required: true,
    },
    confirmTxtColor: {
      required: false,
    },
    buttonTxt: {
      required: true,
    },
    cancelButtonTxt: {
      required: false,
    },
    buttonClick: {
      type: Function,
      required: true,
    },
    cancelButtonNoneFlg: {
      required: false,
    },
    cancelClick: {
      type: Function,
      required: false,
    },
    buttonColor: {
      required: false,
    },
  },
  data: function () {
    return {
      clickButtonFlg: true,
      message: "",
    };
  },
  computed: {
    login_user: {
      get: function () {
        return this.$store.state.control.loginUser;
      },
    },
  },
  created() {
    if (typeof this.buttonClick != "function") {
      this.clickButtonFlg = false;
    }
  },
  methods: {
    /**
     * 登録処理呼び出し
     */
    execBtn() {
      this.buttonClick();
      this.cancelClick();
    },
    closePopup() {
      if (typeof this.cancelClick == "function") {
        this.cancelClick();
      }
    },
  },
};
</script>
